import React, { useState } from 'react';
import appIcon from '../assets/developer-photo.png'
const WelcomeModal = ({ visible, onClose }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: visible ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 2000,
      }}
    >
      <div
        style={{
          width: "90%",
          maxWidth: "400px",
          backgroundColor: "white",
          borderRadius: "20px",
          padding: "24px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "80px",
            height: "80px",
            borderRadius: "60px",
            overflow: "hidden",
            marginBottom: "20px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
          }}
        >
          <img
            src={appIcon} // Developer photo passed as prop
            alt="Developer"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </div>

        <h2
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            marginBottom: "16px",
            textAlign: "center",
          }}
        >
          Hey, I'm Rainier!
        </h2>

        {!expanded ? (
          <>
            <p
              style={{
                fontSize: "16px",
                lineHeight: "1.5",
                marginBottom: "20px",
                textAlign: "center",
                color: "#64748B",
              }}
            >
              I built <span style={{ fontWeight: "bold" }}>Forecast</span> to solve a problem I faced myself—predicting my finances with total clarity. This is just the beginning, and I'm excited for you to be part of it. Thanks for being here. I hope Forecast helps you take control of your future.
            </p>

            <button
              onClick={() => setExpanded(true)}
              style={{
                background: "none",
                border: "none",
                padding: "12px 24px",
                marginBottom: "16px",
                cursor: "pointer",
                color: "#666",
                fontSize: "16px",
                fontWeight: "500",
              }}
            >
              Read More ↓
            </button>
          </>
        ) : (
          <p
            style={{
              fontSize: "16px",
              lineHeight: "1.5",
              marginBottom: "20px",
              textAlign: "center",
              color: "#64748B",
            }}
          >
            I built <span style={{ fontWeight: "bold" }}>Forecast</span> because I struggled to plan my finances with confidence, and existing tools didn't quite work for me. So, I made something better—something built for people like me and you. This is just the beginning. I'm working hard to refine the app, and every early user is helping shape its future. If you ever have feedback, I'm listening. Thanks for being part of this journey. I hope Forecast makes your life easier.
          </p>
        )}

        <button
          onClick={onClose}
          style={{
            backgroundColor: "#2563EB",
            color: "white",
            border: "none",
            borderRadius: "12px",
            padding: "16px 24px",
            fontSize: "18px",
            fontWeight: "600",
            width: "100%",
            cursor: "pointer",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          }}
        >
          Let's Get Started →
        </button>
      </div>
    </div>
  );
};

export default WelcomeModal;